const TRANSLATION_LANG_LOCALE_STORAGE_KEY = 'gulliver-lang';

// TODO: Move to gulliver util-translation
export function setTranslationLang(lang: string, project: string) {
  localStorage.setItem(TRANSLATION_LANG_LOCALE_STORAGE_KEY + '-' + project, lang);
}

// TODO: Move to gulliver util-translation
export function getTranslationLang(project: string) {
  return localStorage.getItem(TRANSLATION_LANG_LOCALE_STORAGE_KEY + '-' + project);
}
